import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    SET_CPD_ALLOCATION: (allocateCpd) => ({ allocateCpd }),
    API: {
      SET_CPD_ALLOCATION: undefined
    }
  }
})

const configuration = {
  name: 'setCpdAllocation',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      createTask: {
        ...state.createTask,
        allocateCpd: action.payload.allocateCpd
      },
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/setCpdAllocation.js